module.exports = __webpack_public_path__ + "img/sld_cb_ta1_ba1_dark.c382c299.svg";